import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, watch } from "vue"
import { useLazyQuery } from "@vue/apollo-composable"
import { FindPromoCodeQuery, FindPromoCodeQueryQuery } from "@/gql"
import Icon from "@/components/widgets/icons/Icon.vue"
import { useUtilities } from "@/hooks/useUtilities"


export default /*#__PURE__*/_defineComponent({
  __name: 'PromoCodeInput',
  props: {
  label: {
    type: String,
    default: "Add Promo Code",
  },
  placeholder: {
    type: String,
    default: "Enter promo code",
  },
  buttonText: {
    type: String,
    default: "Add code",
  },
},
  emits: ["complete"],
  setup(__props, { emit }) {





const { updateSearchParams } = useUtilities()
const form = ref({
  promoCode: "",
})

watch(
  () => form.value,
  () => {
    updateSearchParams({ key: "code", value: form.value.promoCode })
  },
  { deep: true }
)

const promoCodeError = ref<string | null>(null)

const isPromoCodeApplied = computed(() => {
  return promoCode.value?.findPromoCode
})

const {
  load,
  loading: promoCodeLoading,
  result: promoCode,
  onResult: onPromoCodeQueryResult,
} = useLazyQuery<FindPromoCodeQueryQuery>(FindPromoCodeQuery)

onPromoCodeQueryResult((result) => {
  if (result?.data?.findPromoCode?.code) {
    emit("complete", result.data.findPromoCode)
    return
  }

  if (result?.data && !result?.data?.findPromoCode) {
    promoCodeError.value = "*This Promo code does not exists "
  }
})

const onSubmitPromoCode = () => {
  if (!form.value.promoCode) return

  verifyPromoCode()
}
const verifyPromoCode = () => {
  promoCodeError.value = null
  load(undefined, {
    code: form.value.promoCode,
  })
}

const searchParams = new URLSearchParams(window.location.search)

onMounted(() => {
  const code = searchParams.get("code")
  if (code) {
    form.value.promoCode = code
    verifyPromoCode()
  }
})

return { __sfc: true,emit, updateSearchParams, form, promoCodeError, isPromoCodeApplied, load, promoCodeLoading, promoCode, onPromoCodeQueryResult, onSubmitPromoCode, verifyPromoCode, searchParams, Icon }
}

})